export const siteContact = {
  address: '',
  phone: '',
  email: '',
  workHours: '周一至周五 9:00 - 18:00'
}

export const icpFiling = {
  number: '粤ICP备2026106503号',
  url: 'https://beian.miit.gov.cn/'
}
